import { render, staticRenderFns } from "./InvoiceFooter.vue?vue&type=template&id=5780ed65&scoped=true"
import script from "./InvoiceFooter.vue?vue&type=script&lang=js"
export * from "./InvoiceFooter.vue?vue&type=script&lang=js"
import style0 from "./InvoiceFooter.vue?vue&type=style&index=0&id=5780ed65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5780ed65",
  null
  
)

export default component.exports